import { jsonRPCRequest } from './runtime.js';

async function quote(params, config = {}) {
    const result = await jsonRPCRequest("quote", params, config);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return result;
}
async function publishIntent(params, config = {}) {
    const result = await jsonRPCRequest("publish_intent", params, config);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return result;
}
async function publishIntents(params, config = {}) {
    const result = await jsonRPCRequest("publish_intents", params, config);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return result;
}
async function getStatus(params, config = {}) {
    const result = await jsonRPCRequest("get_status", params, config);
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return result;
}

export { getStatus, publishIntent, publishIntents, quote };
//# sourceMappingURL=apis.js.map
